// Must be the first import
if (process.env.NODE_ENV !== 'production') {
  // Must use require here as import statements are only allowed
  // to exist at the top of a file.
  require('preact/debug');
}

// External Imports
import { h, hydrate, render } from 'preact';

// Internal Imports
import { App } from './components/App/App';

// Local Variables
const locale = process.env.LOCALE;

if (!locale) {
  throw new Error('A LOCALE needs to be provided in the environment variable at build time');
}

// Local Functions
async function main() {
  /*
    It's important to fetch translations before attempting to render the App.
    As we are statically prerendering the page during our build process,
    if we don't we will have a hydration conflict which will result in a big content layout shift
  */
  let translations;
  try {
    translations = await import(`./constants/translations/translations-${locale}.json`);
  } catch (error) {
    error.message = `Error while fetching translations: ${error.message}`;
    throw error;
  }
  const rootElement = document.getElementById('app-root');
  const renderOrHydrate = rootElement.hasChildNodes() ? hydrate : render;
  renderOrHydrate(<App locale={locale} translations={translations} />, rootElement);
}

// Render the app
main();
